export const ADMIN_TYPE = 'admin';
export const FUNCIONARIO_TYPE = 'funcionario';
export const SECRETARIA_TYPE = 'secretaria';
export const SUBCOMISION_TYPE = 'subcomision';
export const HELPDESK_TYPE = 'helpdesk';
